import {
  Alert,
  Box,
  Button,
  Chip,
  CssBaseline,
  FilledInput,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  IconButton,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { History, SupportAgent } from "@mui/icons-material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Grid from "@mui/material/Unstable_Grid2";
import CustomCircularProgress, {
  CustomCircularProgressFullScreen,
} from "../../../components/CustomCircularProgress";
import { useEffect, useState } from "react";
import { MuiTelInput } from "mui-tel-input";
import { useOptionTree } from "../../external/hooks/useOptionTree";
import AutoCompleteCustom from "../../../components/AutoCompleteCustom";
import { useOptionTreeParameters } from "../../external/hooks/useOptionTreeParameters";
import TreeViewCustom from "../../../components/TreeViewCustom";
import { AccountTree, Image, Save } from "@mui/icons-material";
import { ITree } from "../../../service/tpclient/interfaces/ITree";
import { useFormDialog } from "../../../hooks/useFormDialog";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import ImageFormDialog from "../../external/components/ImageFormDialog";
import { useOption } from "../../external/hooks/useOption";
import { NumericFormatCustom } from "../../../components/NumericFormatCustom";
import { usePageTitle } from "../../../components/PageTitleProvider";
import { useNotificationSnackbar } from "../../../hooks/useNotificationSnackbar";
import { useValidateString } from "../../../utils/useValidateString";
import { TextMaskCustom } from "../../../components/TextMaskCustom";
import { useLocation, useNavigate } from "react-router-dom";
import numeroPedidoImg from "../../../utils/assets/numero_pedido.gif";
import useGetReversalForms from "../../../hooks/reversal/useGetFormImage";
import lojaImg from "../../../utils/assets/loja.gif";
import useGetReversalFormById from "../../../hooks/reversal/useGetReversalFormById";
import { IReversalDetail } from "../../../service/reversal/interfaces/IReversalDetails";
import useGetBase64 from "../../../hooks/reversal/useGetBase64";
import useUpdateReversal from "../../../hooks/reversal/useUpdateReversalForm";

interface Errors {
  documento: string | null;
  nome: string | null;
  email: string | null;
  pedido: string | null;
  aconteceuPedido: string | null;
  telefone: string | null;
  dataPedido: string | null;
  numeroPedido: string | null;
  loja: string | null;
  descricaoPedido: string | null;
  valor: string | null;
  fotoPedido: string | null;
  notaPedido: string | null;
}

const EditEstorno: React.FC<any> = () => {
  const { setPageTitle } = usePageTitle();
  const { state } = useLocation();
  const navigate = useNavigate();
  const loginUser = localStorage.getItem("Login");
  const profileUser = localStorage.getItem("profile");
  const [isLoadingSave, setIsLoadingSave] = useState<boolean>(false)
  const [reload, setReload] = useState<boolean>(false)
  const { data, isLoading: isLoadingData } = useGetReversalFormById(state.id, state.origin, reload);
  const { data: dataDownload } = useGetReversalForms(state.id);
  const [loading, setLoading] = useState<boolean>(true);
  const { updateReversalForm } = useUpdateReversal();
  const [valueComentario, setValueComentario] = useState<string>("");
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const detailsModel: IReversalDetail = {
    idCase: "",
    documento: "",
    nome: "",
    email: "",
    pedido: "",
    aconteceuPedido: "",
    telefone: "",
    dataPedido: dayjs().startOf("day"),
    numeroPedido: "",
    loja: "",
    descricaoPedido: "",
    valor: "",
    faltaTrocaPedido: "",
    fotoPedido: null,
    notaPedido: null,
    screenshot: null,
    comment: '',
    idTask: '',
    login: '',
  };

  const initError: Errors = {
    documento: null,
    nome: null,
    email: null,
    pedido: null,
    aconteceuPedido: null,
    telefone: null,
    dataPedido: null,
    numeroPedido: null,
    loja: null,
    descricaoPedido: null,
    valor: null,
    fotoPedido: null,
    notaPedido: null,
  };
  const [model, setModel] = useState<IReversalDetail>(detailsModel);
  const [errors, setErrors] = useState<Errors>(initError);
  const [disabled, setDisabled]= useState<boolean>(false)
  const [pedidos, pedidosLoading] = useOptionTree("PEREVI");
  const [lojas, lojasLoading] = useOption("LO3");
  const [aconteceuPedidos] = useOptionTreeParameters("OQACSP", model?.pedido);
  const {getData64} = useGetBase64()
  useEffect(() => {
    if (!pedidosLoading && !lojasLoading) {
      setLoading(false);
    }
  }, [pedidosLoading, lojasLoading]);

  useEffect(() => {
    setPageTitle("Formulario de Estorno");
    if(!isLoadingData) {
      setModel(data)
      setValueComentario(data?.comentario || '');
    }
  }, [setPageTitle, data,isLoadingData , model?.pedido]);

  const { onErrorSnackbar,onSuccessSnackbar } = useNotificationSnackbar();
  const [classifyName, setClassifyName] = useState<string>("");
  const [treeData, setTreeData] = useState<ITree[]>([]);

  const [isOpenFormDialog, titleFormDialog, openFormDialog, closeFormDialog] =
    useFormDialog();

  const [
    isOpenImgFormDialog,
    titleImgFormDialog,
    openImgFormDialog,
    closeImgFormDialog,
  ] = useFormDialog();
  const [imgState, setImgState] = useState<any>();

  const clearError = () => {
    setErrors(initError);
  };
  const { validateEmail } = useValidateString();

  const validFields = () => {
    const valid: boolean[] = [];

    if (!model.documento) {
      setErrors((prevState) => ({
        ...prevState,
        documento: "❌ Campo obrigatório",
      }));
      valid.push(false);
    }

    if (!model.nome.trim()) {
      setErrors((prevState) => ({
        ...prevState,
        nome: "❌ Campo obrigatório",
      }));
      valid.push(false);
    }
    if (!model.email.trim() || !validateEmail(model.email)) {
      setErrors((prevState) => ({
        ...prevState,
        email: "❌ Campo obrigatório",
      }));
      valid.push(false);
    }

    if (!model.telefone.trim()) {
      setErrors((prevState) => ({
        ...prevState,
        telefone: "❌ Campo obrigatório",
      }));
      valid.push(false);
    }

    if (!model.pedido.trim()) {
      setErrors((prevState) => ({
        ...prevState,
        pedido: "❌ Campo obrigatório",
      }));
      valid.push(false);
    }

    if (!model.aconteceuPedido.trim()) {
      setErrors((prevState) => ({
        ...prevState,
        aconteceuPedido: "❌ Campo obrigatório",
      }));
      valid.push(false);
    }

    if (model.dataPedido === null) {
      setErrors((prevState) => ({
        ...prevState,
        dataPedido: "❌ Campo obrigatório",
      }));
      valid.push(false);
    }

      
    if (model.numeroPedido.length < 20) {
      setErrors((prevState) => ({
        ...prevState,
        numeroPedido: "❌ Campo com mínimo de 20 caracteres",
      }));
      valid.push(false);
    }
    
    if (!model.numeroPedido.trim()) {
      setErrors((prevState) => ({
        ...prevState,
        numeroPedido: "❌ Campo obrigatório",
      }));
      valid.push(false);
    }

 

    if (model.numeroPedido.length > 24) {
      setErrors((prevState) => ({
        ...prevState,
        numeroPedido: "❌ Campo com máximo de 24 caracteres",
      }));
      valid.push(false);
    }

    if (!model.loja.trim()) {
      setErrors((prevState) => ({
        ...prevState,
        loja: "❌ Campo obrigatório",
      }));
      valid.push(false);
    }

    if (!model.descricaoPedido.trim()) {
      setErrors((prevState) => ({
        ...prevState,
        descricaoPedido: "❌ Campo obrigatório",
      }));
      valid.push(false);
    }

    if (!model.valor.trim()) {
      setErrors((prevState) => ({
        ...prevState,
        valor: "❌ Campo obrigatório",
      }));
      valid.push(false);
    }
    if(Number(model.valor) >= 1000) {
      setErrors((prevState) => ({
        ...prevState,
        valor: "❌ Excedeu limite do campo valor",
      }));
      valid.push(false);
    }
    return valid.length === 0;
  };

  useEffect(() => {
    if(profileUser === 'GECR') {
      setDisabled(true);
    }
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    clearError();
    if (!validFields()) return;
    setIsLoadingSave(true)
    let updatedFormComentario = { ...model };
    updatedFormComentario = {
      ...updatedFormComentario,
      comment: valueComentario,
    };
    let updatedForm = { ...updatedFormComentario };
    updatedForm = {
      ...updatedForm,
      login: loginUser || '',
    };
    const dataEdited = updatedForm;
    updateReversalForm(dataEdited).then((resp: any) => {
      if(resp?.status === 200) {
          onSuccessSnackbar('Informações salvas com sucesso')
          setReload(true)
          setIsLoadingSave(false)
      }
      else {
        onErrorSnackbar('TENTE NOVAMENTE MAIS TARDE!')
        setIsLoadingSave(false)
      }
    });
  
  };

  const handleDownload = (idCase: string, fileName: string) => {
    getData64(idCase, fileName).then((resp: any) => {
     if(resp.status === 200) {
        const link = document.createElement('a');
         link.href = `data:application/octet-stream;base64,${resp?.data.fileBytesBase64}`;
         link.download = resp.data.attachmentFileName;
         link.click();
     }
    
   })
   
 };

  return (
    <Box
      sx={{
        display: "flex",
        overflowX: "hidden",
      }}
    >
      <CssBaseline />
      <Box
        sx={{
          flex: 1,
          pl: 2,
          pr: 2,
          pb: 2,
          overflowX: "hidden",
        }}
      >
        {(loading || isLoadingData || isLoadingSave) && <CustomCircularProgressFullScreen />}
        {!loading && !isLoadingData && !isLoadingSave &&
          <Box
            component="form"
            id="Screenshot"
            noValidate
            onSubmit={handleSubmit}
          >
            <Grid container spacing={2}>
              <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                <Stack
                  direction="row"
                  alignContent="center"
                  justifyContent="center"
                >
                  <Typography
                    variant={isSmallScreen ? "subtitle1" : "h5"}
                    fontWeight={700}
                  >
                   {state.origin? "FORMULÁRIO DE SOLICITAÇÃO DE ESTORNO" : 
                   'FORMULÁRIO DE ESTORNO'}
                  </Typography>
                </Stack>
              </Grid>
              {state.origin &&
              <>
              <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                <Stack
                  direction="row"
                  alignContent="center"
                  justifyContent="start"
                >
                  <Typography variant={isSmallScreen ? "body2" : "body1"}>
                    Canal destinado para solicitar o estorno do pedido,
                    realizado via McDelivery, App do Méqui, Peça e Retire e
                    Mequizap.
                  </Typography>
                </Stack>
              </Grid>
              <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                <Stack
                  direction="row"
                  alignContent="center"
                  justifyContent="start"
                >
                  <Typography variant={isSmallScreen ? "body2" : "body1"}>
                    Para estorno de pedidos realizados via IFOOD e RAPPI é
                    necessário que entre em contato com o suporte da plataforma
                  </Typography>
                </Stack>
              </Grid>
              </>
}
              <Grid xs={12} sm={12} md={12} lg={12}>
                <FormControl
                  variant="filled"
                  fullWidth
                  required
                  error={!!errors.documento}
               
                >
                  <InputLabel>CPF</InputLabel>
                  <FilledInput
                    value={model?.documento}
                    onChange={(event) =>
                      setModel((prevState: any) => ({
                        ...prevState,
                        documento: event.target.value,
                      }))
                      
                    }
                    inputComponent={TextMaskCustom as any}
                    inputProps={{
                      mask: "000.000.000-00", // Pass the mask as a prop to TextMaskCustom
                    }}
                    disabled={true}
                  />
                  {!!errors.documento && (
                    <FormHelperText error={!!errors.documento}>
                      {errors.documento || ""}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid xs={12} sm={12} md={12} lg={12}>
                <TextField
                  label="QUAL SEU NOME COMPLETO"
                  disabled={state.origin || disabled}
                  variant="filled"
                  value={model?.nome}
                  onChange={(event) =>
                    setModel((prevState: any) => ({
                      ...prevState,
                      nome: event.target.value,
                    }))
                  }
                  fullWidth
                  required
                  error={!!errors.nome}
                  helperText={errors.nome || ""}
                />
              </Grid>
              <Grid xs={12} sm={12} md={12} lg={12}>
                <TextField
                  label="QUAL O SEU E-MAIL DE CONTATO"
                  disabled={state.origin || disabled}
                  variant="filled"
                  value={model?.email}
                  onChange={(event) =>
                    setModel((prevState: any) => ({
                      ...prevState,
                      email: event.target.value,
                    }))
                  }
                  fullWidth
                  required
                  error={!!errors.email}
                  helperText={errors.email || ""}
                />
              </Grid>
              <Grid xs={12} sm={12} md={12} lg={12}>
                <MuiTelInput
                   disabled={state.origin || disabled}
                  label="QUAL O SEU TELEFONE PARA CONTATO"
                  variant="filled"
                  defaultCountry="BR"
                  value={model?.telefone}
                  onChange={(value) =>
                    setModel((prevState: any) => ({
                      ...prevState,
                      telefone: value,
                    }))
                  }
                  fullWidth
                  required
                  error={!!errors.telefone}
                  helperText={errors.telefone || ""}
                />
              </Grid>
              <Grid xs={12} sm={12} md={12} lg={12}>
                <FormControl fullWidth error={!!errors.pedido} required>
                  <FormLabel>
                    SEU PEDIDO FOI REALIZADO VIA DELIVERY, PEÇA E RETIRE OU
                    MEQUI ZAP
                  </FormLabel>
                  <RadioGroup
                  
                    value={model?.pedido || ''}
                    onChange={(event) =>
                      setModel((prevState: any) => ({
                        ...prevState,
                        pedido: event.target.value,
                      }))
                    }
                  >
                    {pedidosLoading && isLoadingData && <CustomCircularProgress size={20} />}
                    {pedidos && !isLoadingData &&
                      pedidos?.options.map((item) => {
                        const label =
                          item.label.split(" – ")[
                            item.label.split(" - ").length
                          ];
                        return (
                          <FormControlLabel
                          disabled={state.origin || disabled}
                            key={item.idBRAN}
                            value={item.idBRAN}
                            control={<Radio />}
                            label={label ?? item.label}
                          />
                        );
                      })}
                  </RadioGroup>
                  {!!errors.pedido && (
                    <FormHelperText error={!!errors.pedido}>
                      {errors.pedido || ""}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              {aconteceuPedidos?.options && (
                <Grid xs={12} sm={12} md={12} lg={12}>
                  <AutoCompleteCustom
                     disabled={state.origin || disabled}
                    title="O QUE ACONTECEU COM SEU PEDIDO"
                    options={aconteceuPedidos?.options ?? []}
                    field="label"
                    fieldId="idBRAN"
                    value={model?.aconteceuPedido}
                    onChange={(id) =>
                      setModel((prevState) => ({
                        ...prevState,
                        aconteceuPedido: id ?? "",
                      }))
                    }
                    variant="filled"
                    required
                    error={errors.aconteceuPedido}
                    startAdornment={
                      <Button
                      disabled={state.origin || disabled}
                        variant="text"
                        size="small"
                        aria-label="AccountTree"
                        onClick={() => {
                          setTreeData(aconteceuPedidos?.tree ?? []);
                          setClassifyName("aconteceuPedido");
                          openFormDialog("O QUE ACONTECEU COM SEU PEDIDO");
                        }}
                      >
                        <AccountTree />
                      </Button>
                    }
                  />
                </Grid>
              )}

              <Grid xs={12} sm={12} md={12} lg={12}>
                <DatePicker
                   disabled={state.origin || disabled}
                  label="EM QUE DATA O SEU PEDIDO FOI FEITO"
                  localeText={{
                    toolbarTitle: "EM QUE DATA O SEU PEDIDO FOI FEITO",
                    cancelButtonLabel: "CANCELAR",
                    okButtonLabel: "OK",
                  }}
                  value={dayjs(model?.dataPedido)}
                  onChange={(newValue: any) => {
                    setModel((prevState) => ({
                      ...prevState,
                      dataPedido: newValue,
                    }));
                  }}
                  format="DD/MM/YYYY"
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      variant: "filled",
                      error: !!errors.dataPedido,
                      helperText: errors.dataPedido || "",
                      required: true,
                    },
                  }}
                />
              </Grid>
              {state.origin &&
              <Grid xs={12} sm={12} md={12} lg={12}>
                <Alert
                  severity="info"
                  sx={{ fontWeight: 700 }}
                  action={
                    <Button
                      size="small"
                      startIcon={<Image />}
                      onClick={() => {
                        setImgState(numeroPedidoImg);
                        openImgFormDialog("EXEMPLO DE NUMERAÇÃO DO PEDIDO");
                      }}
                    >
                      EXEMPLO
                    </Button>
                  }
                >
                  SEMPRE INFORMAR A NUMERAÇÃO COMPLETA DO PEDIDO
                </Alert>
              </Grid>
}
              <Grid xs={12} sm={12} md={12} lg={12}>
                <TextField
                   disabled={state.origin || disabled}
                  label="QUAL É O NÚMERO DO SEU PEDIDO"
                  variant="filled"
                  value={model?.numeroPedido}
                  onChange={(event) =>
                    {
                      if(event.target.value.length >= 20 && event.target.value.length <= 24) {
                    setErrors((prevState: any) => ({
                      ...prevState,
                      numeroPedido: null,
                    }))
                  }
                  else if(event.target.value.length < 20) {
                    setErrors((prevState: any) => ({
                      ...prevState,
                      numeroPedido: "❌ Campo com minímo de 20 caracteres",
                    }))
                  }
                  else {
                    setErrors((prevState: any) => ({
                      ...prevState,
                      numeroPedido: "❌ Campo com máximo de 24 caracteres",
                    }))
                  }
                  setModel((prevState: any) => ({
                    ...prevState,
                    numeroPedido: event.target.value,
                  }))
                  }
                  }
                  fullWidth
                  required
                  error={!!errors.numeroPedido}
                  helperText={errors.numeroPedido || ""}
                />
              </Grid>
              {state.origin &&
              <Grid xs={12} sm={12} md={12} lg={12}>
                <Alert
                  severity="info"
                  sx={{ fontWeight: 700 }}
                  action={
                    <Button
                      startIcon={<Image />}
                      size="small"
                      onClick={() => {
                        setImgState(lojaImg);
                        openImgFormDialog(
                          "EM QUAL LOJA O SEU PEDIDO FOI FEITO"
                        );
                      }}
                    >
                      Exemplo
                    </Button>
                  }
                >
                  EM QUAL LOJA O SEU PEDIDO FOI FEITO
                </Alert>
              </Grid>
}
              <Grid xs={12} sm={12} md={12} lg={12}>
                <AutoCompleteCustom
                   disabled={state.origin || disabled}
                  title="EM QUAL LOJA O SEU PEDIDO FOI FEITO"
                  options={lojas ?? []}
                  field="label"
                  fieldId="idBRAN"
                  value={model?.loja}
                  onChange={(id) =>
                    setModel((prevState) => ({
                      ...prevState,
                      loja: id ?? "",
                    }))
                  }
                  variant="filled"
                  required
                  error={errors.loja}
                />
              </Grid>

              <Grid xs={12} sm={12} md={12} lg={12}>
                <TextField
                   disabled={state.origin || disabled}
                  label="NOS CONTE BREVEMENTE O QUE OCORREU COM O SEU PEDIDO"
                  variant="filled"
                  value={model?.descricaoPedido}
                  onChange={(event) =>
                    setModel((prevState: any) => ({
                      ...prevState,
                      descricaoPedido: event.target.value,
                    }))
                  }
                  fullWidth
                  required
                  error={!!errors.descricaoPedido}
                  helperText={errors.descricaoPedido || ""}
                  multiline
                  rows={5}
                />
              </Grid>
              {state.origin &&
              <Grid xs={12} sm={12} md={12} lg={12}>
                <Alert severity="error" sx={{ fontWeight: 700 }}>
                  EM CASOS DE FALTA DE ITENS, INFORMAR APENAS O VALOR DO ITEM
                  FALTANTE.
                </Alert>
              </Grid>
}
              <Grid xs={12} sm={12} md={12} lg={12}>
                <TextField
                   disabled={state.origin || disabled}
                  label="INFORME O VALOR A SER ESTORNADO"
                  variant="filled"
                  value={model?.valor}
                  onChange={(event) =>
                    {
                      if(Number(event.target.value) < 1000) {
                    setErrors((prevState: any) => ({
                      ...prevState,

                      valor: null,
                    }))
                  }
                  else {
                    setErrors((prevState: any) => ({
                      ...prevState,
                      valor: "❌ Excedeu limite do campo valor",
                    }))
                  }
                  setModel((prevState: any) => ({
                    ...prevState,
                    valor: event.target.value,
                  }))
                  }
                  }
                  InputProps={{
                    inputComponent: NumericFormatCustom as any,
                  }}
                  fullWidth
                  required
                  error={!!errors.valor}
                  helperText={errors.valor || ""}
                />
              </Grid>
              {state.origin &&
              <Grid xs={12} sm={12} md={12} lg={12}>
                <Alert severity="warning" sx={{ fontWeight: 700 }}>
                  RESPONDER APENAS EM CASOS DE "FALTA DE ITENS/PRODUTOS
                  TROCADOS".
                </Alert>
              </Grid>
}
              <Grid xs={12} sm={12} md={12} lg={12}>
                <TextField
                   disabled={state.origin || disabled}
                  label="QUAL ITEM FALTOU EM SEU PEDIDO OU FOI ENVIADO INCORRETAMENTE"
                  variant="filled"
                  value={model?.faltaTrocaPedido}
                  onChange={(event) =>
                    setModel((prevState: any) => ({
                      ...prevState,
                      faltaTrocaPedido: event.target.value,
                    }))
                  }
                  fullWidth
                  multiline
                  rows={5}
                />
              </Grid>
{!state.origin && 
<>
              <Grid xs={12} md={12} lg={12} xl={12}>
            <Chip icon={<History color="warning" />} label={`Histórico`} />
          </Grid>
          <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
            <Box
              sx={{
                borderRadius: 2,
                height: 150,
                overflowY: "auto",
                bgcolor: "background.paper",
              }}
            >
              <Box sx={{ p: 2 }}>
                <Typography variant="body1">
                  {model?.comment}
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
            <TextField
              multiline
              disabled={state.origin || disabled}
              minRows={5}
              inputProps={{
                maxLength: (6000 - (model?.comment ? model?.comment.length : 0)).toString(),
              }}
              helperText={`${valueComentario.length}/${
                 6000 - (model?.comment ? model?.comment.length : 0)
              }`}
              label="Observação"
              variant="filled"
              fullWidth
              name="Observação"
              value={valueComentario}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setValueComentario(event?.target?.value);
              }}
            />
          </Grid>
          </>
}

      <Grid xs={12} md={12} lg={12} xl={12}>
        <Chip icon={<SupportAgent color="error" />} label={"Formulário de Estorno"} />
      </Grid>
      <Grid xs={12} md={12} lg={12} xl={12}>
        <List>
          {dataDownload?.map((item:any, index:any) => (
            <ListItem key={index}>
              <ListItemText primary={item.attachmentDescription.split('#')[1]} />
              <IconButton
                aria-label="download"
                onClick={() => handleDownload(item.caseId, item.attachmentIdEncrypted)}
              >
                <FileDownloadIcon />
              </IconButton>
            </ListItem>
          ))}
        </List>
      </Grid>
              <Grid xs={12} sm={12} md={12} lg={12}>
              <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
             <Button onClick={() => navigate(-1)}>Voltar</Button>
             
             {(profileUser !== 'GECR' && !state.origin) &&
                <Button startIcon={<Save />} type="submit">
                  Salvar
                </Button>
}
                </Stack>
              </Grid>
            </Grid>
          </Box>
}
        <ImageFormDialog
          isOpen={isOpenImgFormDialog}
          title={titleImgFormDialog}
          close={closeImgFormDialog}
          image={imgState}
        />
        <TreeViewCustom
          isOpen={isOpenFormDialog}
          title={titleFormDialog}
          close={closeFormDialog}
          treeData={treeData}
          setSelected={(idBran) => {
            setModel((prevState: any) => ({
              ...prevState,
              [classifyName]: idBran,
            }));
          }}
        />
      </Box>
    </Box>
  );
};

export default EditEstorno;
